// extracted by mini-css-extract-plugin
export default {"WelcomeContainer":"welcome_WelcomeContainer__yczt8","WelcomeInfo":"welcome_WelcomeInfo__XcdHW","actionBtn":"welcome_actionBtn__Z8jfT"};